// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prWhQyfsAFQVLBO4ZcLf {
    position: relative;
    background-color: var(--panel);
    color: var(--on-panel);
    display: inline-flex;
    height: 36px;
    overflow: hidden;
    border-radius: 3px;
}



.prWhQyfsAFQVLBO4ZcLf.KL1tAJl4bq4nINRLTAcS {
    background-color: var(--action);
    color: var(--on-action);
}

.prWhQyfsAFQVLBO4ZcLf::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    height: 8px;
    
    z-index: 2;

    background: linear-gradient(var(--panel), rgba(var(--panel), 0));
}


.prWhQyfsAFQVLBO4ZcLf::after {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    right: 0;
    height: 8px;
    
    z-index: 2;

    background: linear-gradient(rgba(var(--panel), 0), var(--panel));
}

.UEESMYaQCcPv1O91rULY {
    transition: transform 1s ease;
}



.Ru3SAANNQxYkXl7rnExr {
    position: relative;

    width: 24px;
    height: 36px;

    font-family: 'Roboto';
    font-size: 20px;
    font-weight: bold;

    z-index: 1;

    visibility: hidden;
}

.Ru3SAANNQxYkXl7rnExr > * {
    width: 24px;
    height: 36px;
    display: block;

    display: flex;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 1024px) {

    .iINgTHRxShsoiDnLcj8F {
        height: 54px;
    }

    .iINgTHRxShsoiDnLcj8F .Ru3SAANNQxYkXl7rnExr {
        width: 36px;
        height: 54px;
        font-size: 32px
    }

    .iINgTHRxShsoiDnLcj8F .Ru3SAANNQxYkXl7rnExr > * {
        width: 36px;
        height: 54px;
        
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Scorebox.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;;;AAIA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;;IAEX,UAAU;;IAEV,gEAAgE;AACpE;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;;IAEX,UAAU;;IAEV,gEAAgE;AACpE;;AAEA;IACI,6BAA6B;AACjC;;;;AAIA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;;IAEjB,UAAU;;IAEV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;;IAEhB;;AAEJ","sourcesContent":[".container {\r\n    position: relative;\r\n    background-color: var(--panel);\r\n    color: var(--on-panel);\r\n    display: inline-flex;\r\n    height: 36px;\r\n    overflow: hidden;\r\n    border-radius: 3px;\r\n}\r\n\r\n\r\n\r\n.container.highlight {\r\n    background-color: var(--action);\r\n    color: var(--on-action);\r\n}\r\n\r\n.container::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 8px;\r\n    \r\n    z-index: 2;\r\n\r\n    background: linear-gradient(var(--panel), rgba(var(--panel), 0));\r\n}\r\n\r\n\r\n.container::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 8px;\r\n    \r\n    z-index: 2;\r\n\r\n    background: linear-gradient(rgba(var(--panel), 0), var(--panel));\r\n}\r\n\r\n.transitioning {\r\n    transition: transform 1s ease;\r\n}\r\n\r\n\r\n\r\n.digit {\r\n    position: relative;\r\n\r\n    width: 24px;\r\n    height: 36px;\r\n\r\n    font-family: 'Roboto';\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n\r\n    z-index: 1;\r\n\r\n    visibility: hidden;\r\n}\r\n\r\n.digit > * {\r\n    width: 24px;\r\n    height: 36px;\r\n    display: block;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n\r\n    .large {\r\n        height: 54px;\r\n    }\r\n\r\n    .large .digit {\r\n        width: 36px;\r\n        height: 54px;\r\n        font-size: 32px\r\n    }\r\n\r\n    .large .digit > * {\r\n        width: 36px;\r\n        height: 54px;\r\n        \r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `prWhQyfsAFQVLBO4ZcLf`;
export var highlight = `KL1tAJl4bq4nINRLTAcS`;
export var transitioning = `UEESMYaQCcPv1O91rULY`;
export var digit = `Ru3SAANNQxYkXl7rnExr`;
export var large = `iINgTHRxShsoiDnLcj8F`;
export default ___CSS_LOADER_EXPORT___;
